import React from 'react';
import { FileText, Minus, Plus } from 'lucide-react';

export default function ResumePortionPanel({ module, onChange }) {
  const duration = module.duration ?? 15;
  const setDuration = (d) => onChange({ duration: Math.max(1, Math.min(60, d)) });

  return (
    <div className="h-full flex flex-col items-center justify-center text-center">
      <div className="w-12 h-12 rounded-xl bg-[#F1ECFE] flex items-center justify-center mb-5">
        <FileText size={22} className="text-[#5B4FE8]" />
      </div>
      <p className="max-w-[380px] text-[13.5px] text-[#3A3453] leading-relaxed">
        Zara extracts and vets relevant skills found in the candidate's resume.
        We recommend a duration of 15 minutes for an optimal experience.
      </p>

      <div className="mt-8 rounded-2xl bg-[#FAF8FF] border border-[#ECE6FA] px-8 py-5">
        <p className="text-[12.5px] text-[#4A4463] text-center mb-3">Maximum duration (mins)</p>
        <div className="inline-flex items-center gap-6">
          <button
            onClick={() => setDuration(duration - 1)}
            className="w-9 h-9 rounded-lg bg-white border border-[#ECE6FA] text-[#5B4FE8] hover:bg-[#F1ECFE] flex items-center justify-center"
          >
            <Minus size={16} />
          </button>
          <span className="text-[22px] font-bold text-[#1A1533] min-w-[2ch] text-center">{duration}</span>
          <button
            onClick={() => setDuration(duration + 1)}
            className="w-9 h-9 rounded-lg bg-white border border-[#ECE6FA] text-[#5B4FE8] hover:bg-[#F1ECFE] flex items-center justify-center"
          >
            <Plus size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
